import { ReduxState } from "ra-core";

export const USER_ACTIVATE_AUTO_LOGIN = 'OD/USER_ACTIVATE_AUTO_LOGIN'
export const USER_ACTIVATE_AUTO_LOGIN_FAILURE = 'OD/USER_ACTIVATE_AUTO_LOGIN_FAILURE'


export interface UserActivateAutoLoginAction {
  readonly type: typeof USER_ACTIVATE_AUTO_LOGIN;
  readonly payload: {
    username: string,
    password: string,
    vCode: string,
    method: 'RegisterActivate' | 'InvitationActivate',
  };
}

export interface UserActivateAutoLoginFailureAction {
  readonly type: typeof USER_ACTIVATE_AUTO_LOGIN_FAILURE;
  readonly payload: { errMsg: string };
}

export const raiseUserActivateAutoLogin = (username: string, password: string, vCode: string, method: 'RegisterActivate' | 'InvitationActivate'): UserActivateAutoLoginAction => ({
  type: USER_ACTIVATE_AUTO_LOGIN,
  payload: {
    username,
    password,
    vCode,
    method,
  },
})

export const raiseUserActivateAutoLoginFailure = (errMsg: string): UserActivateAutoLoginFailureAction => ({
  type: USER_ACTIVATE_AUTO_LOGIN_FAILURE,
  payload: { errMsg },
})

export const getUserActivateAutoLoginError = (state: ReduxState) => {
  const entry: {id:number, errMsg:string}|undefined = state.admin.resources['autologin']?.data[-1] as any
  return entry?.errMsg
}
